module.exports = __webpack_public_path__ + "static/image-carrusel-hunting-2-1b8fe0322bfc6fb8d4d3c090475c16ec.png";